export default __webpack_public_path__ + "static/media/non_frozen.663ab5ce.png";